const HYPERLINK_REGEX = /\[(?<href>[^[\]]+)\]\((?<title>[^()]+)\)/gi

/**
 * Transform plain text to html with hyperlinks as anchor tags.
 *
 * @param {String} text The text to transform.
 * @returns {String} Returns the transformed html.
 * @example
 *
 * hyperlink('[title](https://www.example.com)')
 * // => '<a href="https://www.example.com">title</a>'
 *
 * // In a sentence.
 * hyperlink('Click [here](google.com) to visit google.')
 * // => 'Click <a href="google.com">here</a> to visit google.'
 */
function hyperlink (text: string, target: string = '_blank'): string {
  return text.replace(HYPERLINK_REGEX, `<a href="$2" target="${target}">$1</a>`)
}

export default hyperlink
